import React from "react";

const OutForDelivery = () => {
  return (
    <>
      <svg
        version="1.1"
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        width="40px"
        height="40px"
        viewBox="0 0 64 64"
        enableBackground="new 0 0 64 64"
        xmlSpace="preserve"
      >
        {" "}
        <image
          id="image0"
          width={64}
          height={64}
          x={0}
          y={0}
          href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAMAAACdt4HsAAAABGdBTUEAALGPC/xhBQAAACBjSFJN
AAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAABuVBMVEUAAABqv0B8ukCEwD+K
xD2GwT9eqkZfq0dfqUdVqlV+u0GMxT1fqkZgq0hmzDOBvz5fq0aAgIBfqUf4gx35lxrwZCPxZCRg
qUb0hh7wZSPyYiRfqkb0hx3wZCLvYyWDwD6KxT3xYyOPyDzxYyOGwj5fqkbwZiRfqkdfqUVmmTNe
qkVfqkZeqUZfq0cA/wBgqkZfqkb3ix/5lhrwZCNgqERfqkZeqkRfq0ZeqkVeqkJfqkZfqkZeqkRf
q0ZfqkZgn0Bms01gq0VeqkZfqkVfqkf3hRz6mhnwZCPxZSP5mhn3iR3xYyOPxjyRyDyFwT9fqkaI
wj51t0Jnr0RhrEaQxz10tkJfq0X5mRrycSDwZCNsskRiq0uTxJC92cvS4+mSw4/6oBn5nBryciFs
sFjB29HX5vDB29D5nRrzcyBgqkbalCT5nRmSw46bnDa92cy92Mqyli/xbSJiq0bR4+j1hh3Q4ufx
bCFiq0rYkyS82creoiFhqkVgqkXboiLzdSDobje7qKelw9ytucjaf1idpjSepjTobzituMftoR1p
qURoqkProR7QoyV0qT+2rbC3rK/ycSHzciH///+egYtDAAAATHRSTlMADJDg+fzYplYGivrcUgXK
iwKJI/biOFCH8TnejvQ+4fkk/pD93yOqWQXg4l9eAcjMIfbhOP48o6Ib8/UefHsIClVUv8OA/ONJ
/H1IL81dqgAAAAFiS0dEkpYE7yAAAAAJcEhZcwAAAdgAAAHYAfpcpnIAAAAHdElNRQflCwIOEwLS
+9S/AAAB/0lEQVRYw2NgGIyAkYmZxYeVjZ2Dkzz9XNy+QODn7+/Pw0uGdj5+X9+AwKBgfzAQECTZ
AH7fkNAwfzgQgksIi4RHREaKihFyv29IlH90TGxcXGx8NMgEcZiMREJCYlJkpKQU/vDj9g31T05J
BYO0ZKAB0rCQlElISEjPiIyUlcNnAJNvQGY0VD/QBKAbsrITkABBN8j7BvrHpMJBjn9uAiogZIKC
b5B/HsKAfP+CBHQTCoEmKOI0QMm3yL8YYUAxpgEJJZGRkco4DVABph8kA0pJNkAVGO4EvFAG9IIa
TgPUgQbEUxKIGkADotPg0Vju71+RTlI0amoBTUhOQ0pI2sgJKRGYmCXxJ2YdUPItz8kvLq7MKQex
dWEyxCVlBj19fxRgAM+OhkagzGRMKDMxmJgi6zc1I6QeE5gjG2BBun4GSyuEfmsbMgxgsEUYYEeO
fgZ7VZh+bQeyDGBwhBngRJ5+BgZniH4XPVI0ubohEmxVNUh/TS1CJLwOmAcj6xsaG5uaQSx3DwwD
PJGTfAvIgFZkkXCQtsi2xsbGdjBLFMMAlDzX0env39WNIgTWFgk0oBHCwm9AQk9vb08CJQZgAioZ
0NfY2E+RAQgwasCoAaMGjBow3A2YgJCfSJYByApGqgETKQ3EgU0Hnvj1h6Ppx2xgeOE1AdLEQdLv
zTBoAACjJDyfdhP4hgAAACV0RVh0ZGF0ZTpjcmVhdGUAMjAyMS0xMS0wMlQxMToxOTowMiswMzow
MNa57nEAAAAldEVYdGRhdGU6bW9kaWZ5ADIwMjEtMTEtMDJUMTE6MTk6MDIrMDM6MDCn5FbNAAAA
GXRFWHRTb2Z0d2FyZQB3d3cuaW5rc2NhcGUub3Jnm+48GgAAAABJRU5ErkJggg=="
        />
      </svg>
    </>
  );
};

export default OutForDelivery;
